import * as React from "react";
const SvgUser = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17 8A5 5 0 1 1 7 8a5 5 0 0 1 10 0m-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0", clipRule: "evenodd" }),
    React.createElement("path", { fill: "currentColor", d: "M12 14a8 8 0 0 0-8 8h2a6 6 0 0 1 12 0h2a8 8 0 0 0-8-8" })));
export default SvgUser;
//# sourceMappingURL=User.js.map